import React from "react";

import { ChartButtonIcon } from "./ChartButtonIcon";
import { ChartCollectionData } from "../../../models/ChartCollectionData";
import { useIndividualFacilityChart } from "../../FacilityDetailsComponents/Analysis/hooks/useIndividualFacilityChart";
import "./styles.scss";

export interface IChartButtonProps {
  chartCollectionData: ChartCollectionData;
  onClick: () => void;
  isActive?: boolean;
}

export const ChartButton: React.FunctionComponent<IChartButtonProps> = (
  props
) => {
  const { chartCollectionData, onClick, isActive } = props;

  const { data: chartData } = useIndividualFacilityChart(
    chartCollectionData.id
  );

  if (!chartData) {
    return <div>loading...</div>;
  }

  return (
    <button
      className={`btn chart-button ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      <span>{chartData.name}</span>
      <ChartButtonIcon type={chartData.type} />
    </button>
  );
};
